import _ from 'lodash'
import { CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { R } from '../R/R'

export default () => {
	const [mod, setMod] = useState(0)

	useEffect(() => {
		let i = 0
		const id = setInterval(() => {
			i = (i + 1) % 4
			setMod(i)
		}, 1_000)

		return () => { clearInterval(id) }
	}, [])

	const ellipsis = _.range(mod).map(() => '.').reduce((a, b) => a + b, '')

	return <div id='loading-page'>
		<div id='center-col'>
			<img id='logo' src={R.images.logoMvp} alt='logo'/>
			<CircularProgress sx={{accentColor: 'white', color: 'white'}} size='4rem'/>
			<h3>Loading{ellipsis}</h3>
		</div>
	</div>
}
